import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { currentCategories } from "@/lib/categories";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { clearRules } from "@/components/RulesBox";

export default function AdminRules() {
  const [all, setAll] = useState(null);
  const [key, setKey] = useState("default");
  useEffect(() => { api.get("/rules").then((r) => setAll(r.data)).catch(() => setAll({})); }, []);
  if (!all) return <p className="text-sm text-slate-400 py-6 text-center">Duke ngarkuar...</p>;
  const cats = currentCategories().filter((c) => !["komunitete", "punekerkues"].includes(c.key));
  const r = all[key] || all.default || {};
  const set = (patch) => setAll({ ...all, [key]: { ...r, ...patch } });
  const save = async () => {
    try { const res = await api.put("/admin/rules", all); setAll(res.data); clearRules(); toast.success("Rregullat u ruajtën"); }
    catch { toast.error("Nuk u ruajt"); }
  };
  const reset = async () => {
    const n = { ...all }; delete n[key];
    try { const res = await api.put("/admin/rules", n); setAll(res.data); clearRules(); toast.success("U kthye teksti bazë"); }
    catch { toast.error("Nuk u ruajt"); }
  };
  return (
    <div data-testid="admin-rules" className="space-y-3 bg-white rounded-2xl p-4 border border-slate-100">
      <select data-testid="admin-rules-cat" value={key} onChange={(e) => setKey(e.target.value)} className="w-full h-11 rounded-xl border border-slate-200 px-3 text-sm">
        <option value="default">Të gjitha shpalljet (bazë)</option>
        {cats.map((c) => <option key={c.key} value={c.key}>{c.label}{all[c.key] ? " ✓" : ""}</option>)}
      </select>
      {key !== "default" && !all[key] && <p className="text-xs text-slate-500">Kjo kategori përdor tekstin bazë. Ndryshoje më poshtë për ta bërë të veçantë.</p>}
      <label className="text-xs font-semibold text-slate-500">Titulli</label>
      <Input data-testid="admin-rules-title" value={r.title || ""} onChange={(e) => set({ title: e.target.value })} className="rounded-xl" />
      <label className="text-xs font-semibold text-slate-500">Hyrja</label>
      <Input data-testid="admin-rules-intro" value={r.intro || ""} onChange={(e) => set({ intro: e.target.value })} className="rounded-xl" />
      <label className="text-xs font-semibold text-slate-500">Rregullat (një për rresht)</label>
      <Textarea data-testid="admin-rules-items" rows={8} value={(r.items || []).join("\n")} onChange={(e) => set({ items: e.target.value.split("\n") })} className="rounded-xl" />
      <label className="text-xs font-semibold text-slate-500">Teksti në fund</label>
      <Input data-testid="admin-rules-footer" value={r.footer || ""} onChange={(e) => set({ footer: e.target.value })} className="rounded-xl" />
      <label className="text-xs font-semibold text-slate-500">Teksti te kutia "pranoj"</label>
      <Input data-testid="admin-rules-accept" value={r.accept || ""} onChange={(e) => set({ accept: e.target.value })} className="rounded-xl" />
      <div className="flex gap-2">
        <Button data-testid="admin-rules-save" onClick={save} className="flex-1 rounded-xl bg-emerald-500 hover:bg-emerald-600">Ruaj</Button>
        {key !== "default" && all[key] && <Button data-testid="admin-rules-reset" variant="outline" onClick={reset} className="rounded-xl">Përdor bazën</Button>}
      </div>
    </div>
  );
}
